import * as React from 'react';
import { Responsive, TooltipMobile } from '@cian/ui-kit';

interface IAwardCardTooltipProps {
  text: string;
  children: React.ReactElement;
}

export const AwardCardTooltip = ({ children, text }: IAwardCardTooltipProps) => {
  return (
    <>
      <Responsive desktop>{children}</Responsive>
      <Responsive phone tablet>
        <TooltipMobile title={text}>{children}</TooltipMobile>
      </Responsive>
    </>
  );
};
